import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'myze-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'MYZE',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 2489637933,
  email: 'support@myze.com',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/myze/index.js